import { useQuery } from "@tanstack/react-query";
import { CACHE_KEYS } from "@api/constants/cacheKeys";
import { useState } from "react";
import { ICommonServiceProps } from "@api/types/globalService.types";
import useGlobalDebounceHandler from "./useGlobalDebounceHandler";
import URLS from "@api/constants/urls";
import { handleGlobalGetRequestQuery } from "@api/functions/getRequests";
import { urlUtility } from "@repo/utilities/url.utility.ts";
import { resolveFilters } from "@api/utilities/api.utility";

export const useGetAllClaimsService = ({
  page = "1",
  per_page = "15",
  enableQuery = true,
  cacheKeys = [],
  filters = {},
}: ICommonServiceProps) => {
  const [userSearchQuery, setUserSearchQuery] = useState("");
  const { debouncedQuery } = useGlobalDebounceHandler(userSearchQuery);
  const resolvedFilters = resolveFilters(filters);
  const allClaimsService = useQuery({
    queryKey: [
      ...CACHE_KEYS.CLAIMS,
      page,
      per_page,
      debouncedQuery,
      JSON.stringify(resolvedFilters),
      ...cacheKeys,
    ],

    queryFn: () => {
      return handleGlobalGetRequestQuery({
        url: URLS?.CLAIMS,
        searchParams: {
          page,
          per_page,
          include:
            "claim_stage,certificate,claim_expenses,claim_type,certificate.certificatable.segment",
          ...resolvedFilters,
        },
      });
    },

    enabled: enableQuery,
  });

  return {
    service: { allClaimsService },
    states: { userSearchQuery, setUserSearchQuery },
  };
};

export const useGetSingleClaimService = () => {
  const urlQueries = urlUtility.getUrlQueries(location.search);
  const claimId = urlQueries["claim-id"] || "";
  const getSingleClaimService = useQuery({
    queryKey: [...CACHE_KEYS.CLAIMS, claimId],
    queryFn: () => {
      return handleGlobalGetRequestQuery({
        url: `${URLS?.CLAIMS}/${claimId}`,
      });
    },
    enabled: claimId ? true : false,
  });

  return { service: { getSingleClaimService } };
};
